import { Icon } from '@gftg/ui';

/**
 * The one contact route this release has. PRF-05 keeps email and phone off every attendee-facing
 * screen, and the questionnaire names LinkedIn as the link other attendees can see — so this is
 * the button on a profile, on a match and on a presenter, and it leaves the app (HOME-05).
 */
export function LinkedInButton({ url, grow = false }: { url: string; grow?: boolean }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer noopener"
      className={`text-button rounded-button flex min-h-touch items-center justify-center gap-1.5 bg-brand-wash px-4 font-semibold whitespace-nowrap text-brand-text ${
        grow ? 'flex-1 basis-0' : ''
      }`}
    >
      LinkedIn
      <Icon name="external" size={12} aria-hidden="true" />
      <span className="sr-only">Opens outside the app</span>
    </a>
  );
}
